import React, { useState, useEffect } from "react";
import styles from "./Header.module.css";
import { GlassButton } from "../CtaButton/GlassButton";
import { usePlausible } from "../../hooks/usePlausible";
import {
  INVITE_BOT,
  INVITE_BOT_HEADER,
  DOWNLOAD_APP,
  DOWNLOAD_APP_HEADER,
  DOCS_VISIT,
  DOCS_VISIT_HEADER,
  PREMIUM_VISIT,
  PREMIUM_VISIT_HEADER,
  trackButtonClick,
  trackButtonClickWithNavigation,
} from "../../utils/analytics";
import { isBrowser } from "../../utils/ssrUtils";
import { APP_LINKS, BRAND, SOCIAL_LINKS } from "../../constants/socialLinks";

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const trackEvent = usePlausible();

  useEffect(() => {
    // Skip on server-side
    if (!isBrowser()) return;

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`${styles.header} ${isScrolled ? styles.headerScrolled : ""}`}
    >
      <div className={styles.headerContent}>
        <div className={styles.logo}>
          <a href={APP_LINKS.home} className={styles.logoLink}>
            <img
              src={BRAND.logo}
              alt={BRAND.name}
              className={styles.logoImage}
            />
          </a>
        </div>
        <nav className={styles.navigation}>
          <ul>
          <li>
              <a
                href={APP_LINKS.home}
                className={styles.docsLink}
                onClick={trackButtonClickWithNavigation(
                  trackEvent,
                  DOWNLOAD_APP,
                  DOWNLOAD_APP_HEADER,
                  APP_LINKS.home
                )}
              >
                Home
              </a>
            </li>
            <li>
              <a
                href={APP_LINKS.premium}
                className={styles.docsLink}
                onClick={trackButtonClickWithNavigation(
                  trackEvent,
                  PREMIUM_VISIT,
                  PREMIUM_VISIT_HEADER,
                  APP_LINKS.premium
                )}
              >
                Premium
              </a>
            </li>
            <li>
              <a
                href={SOCIAL_LINKS.discord.url}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.docsLink}
                onClick={() =>
                  trackButtonClick(trackEvent, DOCS_VISIT, DOCS_VISIT_HEADER)
                }
              >
                Discord
              </a>
            </li>


          </ul>
        </nav>
        <div className={styles.headerActions}>
          <a
            href={SOCIAL_LINKS.discord.url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.discordIcon}
            aria-label="Join our Discord server"
          >
            <img
              src={SOCIAL_LINKS.discord.icon}
              alt="Discord"
              className={styles.discordIconImage}
            />
          </a>
          <GlassButton
            href={APP_LINKS.invite}
            buttonType="secondary"
            className={styles.inviteButton}
            onClick={() =>
              trackButtonClick(trackEvent, INVITE_BOT, INVITE_BOT_HEADER)
            }
          >
            Invite Bot
          </GlassButton>
        </div>
      </div>
    </header>
  );
};

export default Header;
